/**
 * Creates the return receipt header
 * @param {Object} restaurant - Restaurant information
 * @param {Object} order - Order details
 * @param {Function} t - Translation function
 * @param {String} language - Current language
 * @returns {String} - HTML content for the return receipt header
 */

const createReturnHeader = (restaurant, order, t, language) => {
  // Get restaurant name and address based on language
  const name = restaurant.name_ar || restaurant.name;
  const address = restaurant.address_ar || restaurant.address;
  
  // Format the date in Gregorian format (DD/MM/YYYY)
  let orderDate = new Date();
  if (order.created_at && !isNaN(new Date(order.created_at).getTime())) {
    orderDate = new Date(order.created_at);
  }
  
  // Format date in Gregorian format (DD/MM/YYYY)
  const day = String(orderDate.getDate()).padStart(2, '0');
  const month = String(orderDate.getMonth() + 1).padStart(2, '0');
  const year = orderDate.getFullYear();
  const hours = String(orderDate.getHours()).padStart(2, '0');
  const minutes = String(orderDate.getMinutes()).padStart(2, '0');
  
  const date = `${day}/${month}/${year}`;
  const time = `${hours}:${minutes}`;

  return `
    <!-- Ultra-simple header for maximum thermal printer compatibility -->
    <center>
      <!-- Restaurant Name with proper RTL handling -->
      <div dir="rtl" style="font-weight: bold; font-size: 12px; font-family: Tahoma, Arial, 'Simplified Arabic', sans-serif; letter-spacing: 0;">
        ${name}
      </div>
      
      <!-- Address -->
      ${address ? `<div dir="rtl" style="font-size: 10px; font-family: Tahoma, Arial, 'Simplified Arabic', sans-serif; letter-spacing: 0;">${address}</div>` : ''}
      
      <!-- Phone -->
      ${restaurant.phone ? 
        `<div dir="rtl" style="font-size: 10px; font-family: Tahoma, Arial, 'Simplified Arabic', sans-serif; letter-spacing: 0;">
          ${t('cashier.receipt.phone')}: ${restaurant.phone}
        </div>` : ''
      }
      
      <!-- Return Receipt Notice -->
      <div style="
        background-color: #f8f8f8;
        border: 1px solid #000;
        padding: 3px;
        margin: 5px 0;
        border-radius: 3px;
      ">
        <div dir="rtl" style="
          font-size: 12px;
          font-weight: bold;
          font-family: Tahoma, Arial, 'Simplified Arabic', sans-serif;
          letter-spacing: 0;
          color: #000;
        ">
          ${t('cashier.receipt.returnReceipt')}
        </div>
      </div>
      
      <!-- Divider -->
      <div style="border-bottom: 1px dashed #000; margin: 5px 0;"></div>
      
      <!-- Tax Invoice Title - ultra simple -->
      <div dir="rtl" style="
        font-size: 12px;
        font-weight: bold;
        padding: 3px 0;
        font-family: Tahoma, Arial, 'Simplified Arabic', sans-serif;
        letter-spacing: 0;
      ">
        ${order.customer_type === 'company' 
          ? t('cashier.receipt.taxInvoice')
          : t('cashier.receipt.simplifiedTaxInvoice')
        }
      </div>
      
      <!-- Divider -->
      <div style="border-bottom: 1px solid #000; margin: 5px 0;"></div>
      
      <!-- Tax Number -->
      ${restaurant.tax_number ? 
        `<div dir="rtl" style="font-size: 10px;">
          ${t('cashier.receipt.taxNumber')}: ${restaurant.tax_number}
        </div>` : ''
      }
    </center>
    
    <!-- Order Details - kept extremely simple -->
    <div dir="rtl" style="
      display: flex;
      justify-content: space-between;
      font-size: 10px;
      margin: 5px 0;
      font-family: 'Courier New', monospace;
    ">
      <div>
        ${t('cashier.receipt.orderNumber')}: ${order.order_number || order.id || ''}
      </div>
      <div>
        ${t('cashier.receipt.date')}: ${date} ${time}
      </div>
    </div>
  `;
};

export default createReturnHeader;
